import React, { useEffect, useState } from "react";
import TopHeader from "../components/TopHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchArticles,
  selectAllArticles,
  setItemsPerPage,
} from "../store/slices/blogSlice";
import Article from "../components/Article";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import PublishedDate from "../components/PublishedDate";
import Pagination from "../components/Pagination";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

function Blog() {
  const dispatch = useDispatch();
  const {
    status,
    error,
    articles,
    currentPage,
    itemsPerPage,
    next_page_url,
    prev_page_url,
    lastPage,
  } = useSelector((state) => state.blog);
  const navigate = useNavigate();
  // console.log("articles", articles); ////rend [] vide pourtant il ya valeur

  const handlePageChange = (page) => {
    if (page >= 1 && page <= lastPage) {
      dispatch(fetchArticles({ page, itemsPerPage }));
    }
  };

  const handlePerPageChange = (perPage) => {
    dispatch(fetchArticles({ page: 1, itemsPerPage: perPage }));
  };

  useEffect(() => {
    dispatch(fetchArticles({ page: currentPage, itemsPerPage }));
  }, [dispatch, currentPage, itemsPerPage]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Page Blog </title>
          <meta name="description" content="liste des articles " />
        </Helmet>
      </HelmetProvider>
      <TopHeader btn={true} />
      <div className="container mt-40">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item grey66 body">
              <a href="/">Accueil</a>
            </li>
            <li
              className="breadcrumb-item active grey66 body"
              aria-current="page"
            >
              Blog
            </li>
          </ol>
        </nav>

        <h2>Découvrez l’actualité Twyny</h2>
        <div className="row mt-40 pointer">
          {status === "loading" ? (
            <>
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <Skeleton height={300} className="width-100" />
              </div>
              <div className="col-12 col-md-6 article-description">
                <Skeleton height={32} width={`80%`} />
                <Skeleton count={3} className="mt-16" />
                <Skeleton width={`40%`} className="mt-24" />
              </div>
            </>
          ) : (
            articles[0] && (
              <div
                className="row mt-40 pointer"
                onClick={() =>
                  navigate(`/articles/${articles[0]?.id}`, {
                    replace: true,
                  })
                }
              >
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                  <img
                    src={`${process.env.REACT_APP_ARTICLE_URL}${articles[0]?.featured_image_url}`}
                    alt="blog"
                    className="article width-100"
                  />
                </div>
                <div className="col-12 col-md-6 article-description">
                  <h3>{articles[0]?.titre}</h3>
                  <div className="body bold500 grey-light mt-16">
                    {articles[0]?.description}
                  </div>

                  {articles[0]?.published_at && (
                    <div className="mt-24">
                      <PublishedDate published_at={articles[0]?.published_at} />
                    </div>
                  )}
                </div>
              </div>
            )
          )}
        </div>

        <div className="row mt-32">
          {status === "loading"
            ? Array.from({ length: 3 }).map((_, index) => (
                <div className="col-md-4 cadre-article" key={index}>
                  <Skeleton height={180} />
                  <Skeleton height={24} className="mt-16" />
                  <Skeleton count={3} className="mt-8" />
                </div>
              ))
            : articles
                ?.slice(1)
                .map((element, index) => (
                  <Article
                    className="pointer"
                    element={element}
                    key={index + 1}
                    onClick={() => navigate(`/articles/${element?.id}`)}
                  />
                ))}
        </div>

        <Pagination
          currentPage={currentPage}
          lastPage={lastPage}
          perPage={itemsPerPage}
          onPageChange={handlePageChange}
          onPerPageChange={handlePerPageChange}
        />
      </div>
      <Footer />
    </>
  );
}

export default Blog;
